

import Tabs from '@/components/Tabs';
import Tips from '@/components/Tips';
import Noresult from '@/components/Noresult';
import api from '../../api';

export default {
components: { Tips, Tabs, Noresult },
mounted() {
const id = this.$route.query.id;
if (id) {
this.id = id;
this.getTenderDetail();
this.getDetail();
}
},
data: () => ({
tabsDatas: [
{ text: '已报名', key: 1 },
{ text: '已应标', key: 2 },
{ text: '已投标', key: 3 },
{ text: '已中标', key: 4 },
],
id: '',
tender: {},
inviteStage: {},
lower: {},
roundsStage: {},
signup: {},
tenderDetail: {},
}),
computed: {
allDic() {
return this.$store.state.allDic;
},
addrListById() {
return this.$store.state.addrListById;
},
},
methods: {
tabClick(activeKey) {
console.log(activeKey);
},
toDetail() {
this.$router.push({
path: '/hall/detail',
query: {
id: this.id,
},
});
},
getDetail() {
api.vega.tender.lowerBid({
tenderId: this.id,
}).then((res) => {
const data = res.data.data;
this.inviteStage = data.inviteStage;
this.lower = data.upper;
this.roundsStage = data.roundsStage;
this.signup = data.signup;
this.tender = data.tender;
})
},
getTenderDetail() {
api.vega.tender.detail({
tenderId: this.id,
}).then((res) => {
const data = res.data.data;
this.tenderDetail = data;
});
},
goodsType(type) {
let goodsType = '--';
if (this.allDic['goodsType']) {
this.allDic['goodsType'].children.map((item) => {
if (`${type}` === item.id) {
goodsType = item.value;
}
return item;
})
}
return goodsType;
},
findCity(p, c) {
let addr = '';
const addrList = this.addrListById;
const _addrList = JSON.stringify(addrList);
if (_addrList !== '{}') {
addr = `${p ? addrList[p].content : ''}${p && c ? '·' : ''}${c && addrList ? addrList[c].content : ''}`;
}
return addr;
},
download(url) {
if (url !== '') {
const newTab = window.open('about:blank');
newTab.location.href = url;
}
},
nowStateLow(state, rounds, stage) { // 状态机
let r = '第一轮报价';
let t = '已报名';
let c = 'status_warning';
switch (rounds) {
case 2:
r = '第二轮报价';
break;
case 3:
r = '第三轮报价';
break;
default:
r = '第一轮报价';
break;
}
if (stage === 10) { // 报名阶段
switch (state) {
case 3:
t = '已报名';
c = 'status_danger';
break;
case 5:
t = '报名未通过';
c = 'status_danger';
break;
case 8:
t = '已关闭';
c = 'status_info';
break;
default:
t = '已报名';
c = 'status_danger';
break;
}
} else if (stage === 20) { // 邀标应标阶段
switch (state) {
case 1:
t = '待应标';
c = 'status_warning';
break;
case 2:
t = '未应标';
c = 'status_info';
break;
case 3:
t = '已应标';
c = 'status_danger';
break;
case 5:
t = '应标未通过';
c = 'status_danger';
break;
case 8:
t = '已关闭';
c = 'status_info';
break;
default:
t = '待应标';
c = 'status_warning';
break;
}
} else if (stage === 30) { // 投标阶段
switch (state) {
case 1:
t = '待投标';
c = 'status_warning';
break;
case 2:
t = '未投标';
c = 'status_info';
break;
case 3:
t = '已投标';
c = 'status_danger';
break;
case 5:
t = '未中标';
c = 'status_info';
break;
case 6:
t = '已中标';
c = 'status_danger';
break;
case 7:
t = '未中标';
c = 'status_info';
break;
default:
t = '待投标';
c = 'status_warning';
break;
}
}
return {
r,
t,
c,
};
},
nowStateLowImg(state, rounds, stage) { // 状态机
let t = require('../../assets/images/ybmdsh@3x.png');
if (stage === 10) { // 报名阶段
switch (state) {
case 3:
t = require('../../assets/images/ybmdsh@3x.png');
break;
case 5:
t = require('../../assets/images/bmwtg@3x.png');
break;
case 8:
t = require('../../assets/images/closed@3x.png');
break;
default:
t = require('../../assets/images/ybmdsh@3x.png');
break;
}
} else if (stage === 20) { // 邀标应标阶段
switch (state) {
case 1:
t = require('../../assets/images/dyb@3x.png');
break;
case 2:
t = require('../../assets/images/wyb@3x.png');
break;
case 3:
t = require('../../assets/images/yybdsh@3x.png');
break;
case 5:
t = require('../../assets/images/no-pass@3x.png');
break;
case 8:
t = require('../../assets/images/closed@3x.png');
break;
default:
t = require('../../assets/images/dyb@3x.png');
break;
}
} else if (stage === 30) { // 投标阶段
switch (state) {
case 1:
t = require('../../assets/images/dtb@3x.png');
break;
case 2:
t = require('../../assets/images/wtb@3x.png');
break;
case 3:
t = require('../../assets/images/ytbdsh@3x.png');
break;
case 5:
t = require('../../assets/images/wzb@3x.png');
break;
case 6:
t = require('../../assets/images/yzb@3x.png');
break;
case 7:
t = require('../../assets/images/wzb@3x.png');
break;
default:
t = require('../../assets/images/dtb@3x.png');
break;
}
}
return t;
},
nowStateUp(state, rounds) { // 状态机
let t = '待审核';
let r = '第一轮';
switch (state) {
case 20:
t = '审核不通过';
break;
case 30:
t = '报名中';
break;
case 40:
t = '待邀标';
break;
case 50:
t = '应标中';
break;
case 60:
t = '待招标';
break;
case 70:
t = '投标中';
break;
case 80:
t = '开标中';
break;
case 90:
t = '已完成';
break;
case 100:
t = '已关闭';
break;
case 110:
t = '已取消';
break;
default:
t = '待审核';
break;
}
switch (rounds) {
case 2:
r = '第二轮报价';
break;
case 3:
r = '第三轮报价';
break;
default:
r = '第一轮报价';
break;
}
return {
t,
r,
};
},
nowStateTop(state) { // 状态机
let t = 1;
switch (state) {
case 20:
t = 0;
break;
case 30:
t = 1;
break;
case 40:
t = 1;
break;
case 50:
t = 2;
break;
case 60:
t = 2;
break;
case 70:
t = 3;
break;
case 80:
t = 3;
break;
case 90:
t = 4;
break;
case 100:
t = 0;
break;
case 110:
t = 0;
break;
default:
t = 1;
break;
}
return t;
},
rounds(rounds) {
let t = '一';
switch (rounds) {
case 2:
t = '二';
break;
case 3:
t = '三';
break;
default:
t = '一';
break;
}
return t;
},
},
};
